import { render, staticRenderFns } from "./userchart.vue?vue&type=template&id=31f9e012&"
import script from "./userchart.vue?vue&type=script&lang=js&"
export * from "./userchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports